import { useEffect, useState } from "react";

const getBaseUrl = (permitTypeId) => {
    const urlMap = {
        41: 10, 42: 11, 43: 12, 44: 13, 45: 14, 46: 15,
        47: 16, 48: 17, 49: 18, 50: 19, 51: 20, 52: 21, 53: 22,
        54: 23, 55: 24, 56: 25, 57: 26, 58: 27, 59: 28,
        //II_III_STADIA_POLYGON_NEW
        11: 7, 14: 7, 18: 7, 167: 7, 192: 7,
        //I_STADIA_POLYGON_NEW
        4: 3, 6: 3, 7: 3, 8: 3, 9: 3, 158: 3, 159: 3, 160: 3,
        161: 3, 162: 3, 163: 3, 164: 3, 171: 3, 212: 3, 213: 3,
        214: 3, 215: 3,
        //AFETQEBA_NEBARTVA
        39: 0
    };

    const layerId = urlMap[permitTypeId];
    return layerId !== undefined
        ? `https://gis.economy.ge/server/rest/services/TCSA/TCSAGraphics/FeatureServer/${layerId}/query`
        : "";
};

export const useFeatureExists = (caseData) => {
    const [featureExists, setFeatureExists] = useState(false);

    useEffect(() => {
        if (!caseData?.caseNumber || !caseData?.permitTypeId) return;

        const baseUrl = getBaseUrl(caseData.permitTypeId);
        if (!baseUrl) return;

        const queryParams = new URLSearchParams({
            where: `gancxadebis_nomeri='${caseData.caseNumber}'`,
            returnCountOnly: "true",
            f: "json",
        });

        const fullTargetUrl = `${baseUrl}?${queryParams.toString()}`;
        const cleanBaseURL = baseUrl?.replace("/api", "");
        const proxyUrl = `${cleanBaseURL}/DotNet/proxy.ashx?${encodeURIComponent(fullTargetUrl)}`;

        fetch(proxyUrl)
            .then((res) => res.json())
            .then((data) => {
                setFeatureExists(data.count > 0);
            })
            .catch((err) => {
                console.error("Proxy request failed:", err);
                setFeatureExists(false);
            });

    }, [caseData?.caseNumber, caseData?.permitTypeId]);

    return featureExists;
};
